import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { FiDateFormatOptions } from '@fi-shared/utils';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export interface IWrapperTableTimeCellData {
    date: Date | string;
    stateSref?: string;
    stateSrefParams?: { [param: string]: number | string };
    linkLabel?: string;
    secondaryValue?: string;
}

// todo: rename to FiWrapperTableDateCellComponent
@Component({
    selector: 'fi-wrapper-table-time-cell',
    template: `
        <fi-wrapper-table-span-cell [value]="getDateValue()"></fi-wrapper-table-span-cell>
        @if (!isAdditionalElementSpan) {
          <fi-wrapper-table-a-cell
            [value]="value.linkLabel"
            [stateSref]="value.stateSref"
            [stateSrefParams]="value.stateSrefParams"
            (linkElementClick)="onLinkElementClick($event)"
            >
          </fi-wrapper-table-a-cell>
        }
        <fi-wrapper-table-span-cell
          class="cursor-pointer"
          (click)="secondaryValueClick()"
          [value]="value.secondaryValue"
          >
        </fi-wrapper-table-span-cell>
        `,
    styleUrls: ['./fi-wrapper-table-time-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-time-cell' },
    standalone: false,
})
export class FiWrapperTableTimeCellComponent extends FiWrapperTableCellBase<IWrapperTableTimeCellData> {
    @Input() isAdditionalElementSpan: boolean;
    @Output() onSecondaryValueClick = new EventEmitter<void>();

    constructor(private fiFormatDateService: FiFormatDateService) {
        super();
    }

    getDateValue(): string {
        if (typeof this.value.date === 'string') {
            if (this.value.date.indexOf('T') === 10) {
                return this.fiFormatDateService.formatDate(new Date(this.value.date), FiDateFormatOptions);
            }
            return this.value.date;
        }
        return this.fiFormatDateService.formatDate(this.value.date, FiDateFormatOptions);
    }

    onLinkElementClick($event) {}

    secondaryValueClick() {
        this.onSecondaryValueClick.emit();
    }
}
